import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,_vm._b({attrs:{"outlined":"","dense":"","label":_vm.$t('Group by'),"hide-details":"auto","multiple":"","items":_vm.options,"clearable":""},model:{value:(_vm.paramsGroup),callback:function ($$v) {_vm.paramsGroup=$$v},expression:"paramsGroup"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }